import { render, staticRenderFns } from "./sub-category.vue?vue&type=template&id=d1c67c9e&scoped=true"
import script from "./sub-category.vue?vue&type=script&lang=js"
export * from "./sub-category.vue?vue&type=script&lang=js"
import style0 from "./sub-category.vue?vue&type=style&index=0&id=d1c67c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c67c9e",
  null
  
)

export default component.exports